module.exports = __webpack_public_path__ + "static/media/narciso-rodriguez-for-her-big.bd5d2570.png";